// Mxltiverse — 8-bit sound effects synthesizer (Web Audio API)
// Generates square/triangle wave blips, no audio files needed.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!ctx) {
    ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  if (ctx.state === 'suspended') {
    ctx.resume();
  }
  return ctx;
}

interface ToneOpts {
  freq: number;
  duration: number;
  type?: OscillatorType;
  volume?: number;
  sweep?: number;
}

function playTone({ freq, duration, type = 'square', volume = 0.15, sweep }: ToneOpts) {
  const ac = getCtx();
  const osc = ac.createOscillator();
  const gain = ac.createGain();

  osc.type = type;
  osc.frequency.setValueAtTime(freq, ac.currentTime);
  if (sweep) {
    osc.frequency.exponentialRampToValueAtTime(
      Math.max(sweep, 20),
      ac.currentTime + duration
    );
  }

  gain.gain.setValueAtTime(volume, ac.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + duration);

  osc.connect(gain);
  gain.connect(ac.destination);
  osc.start(ac.currentTime);
  osc.stop(ac.currentTime + duration);
}

function playSequence(tones: ToneOpts[], delay = 0) {
  const ac = getCtx();
  let t = delay;
  for (const tone of tones) {
    setTimeout(() => playTone(tone), t * 1000);
    t += tone.duration;
  }
}

// ====== Sound effects ======

export const sfx = {
  key() {
    playTone({ freq: 160 + Math.random() * 40, duration: 0.04, type: 'square', volume: 0.05 });
  },

  focus() {
    playTone({ freq: 660, duration: 0.04, type: 'square', volume: 0.06 });
  },

  click() {
    playTone({ freq: 440, duration: 0.05, type: 'square', volume: 0.1, sweep: 880 });
  },

  toggle() {
    playTone({ freq: 880, duration: 0.04, type: 'square', volume: 0.08 });
    setTimeout(() => playTone({ freq: 660, duration: 0.04, type: 'square', volume: 0.08 }), 40);
  },

  select() {
    playTone({ freq: 523, duration: 0.05, type: 'square', volume: 0.08, sweep: 784 });
  },

  success() {
    playSequence([
      { freq: 523, duration: 0.08, type: 'square', volume: 0.1 },
      { freq: 659, duration: 0.08, type: 'square', volume: 0.1 },
      { freq: 784, duration: 0.12, type: 'square', volume: 0.1 },
    ]);
  },

  error() {
    playTone({ freq: 200, duration: 0.15, type: 'sawtooth', volume: 0.12, sweep: 100 });
    setTimeout(() => playTone({ freq: 150, duration: 0.2, type: 'sawtooth', volume: 0.12, sweep: 80 }), 100);
  },

  verify() {
    playSequence([
      { freq: 784, duration: 0.06, type: 'square', volume: 0.1 },
      { freq: 1047, duration: 0.1, type: 'square', volume: 0.1 },
    ]);
  },
};
